import {
  SUBMIT_DIALOG_SHOW,
  APPTOOLBAR_SET_CONSTRAINTS,
  APPTOOLBAR_RESET_APP_STATE,
  APPTOOLBAR_SELECT_CHAMBER_TYPE,
  APPTOOLBAR_SWITCH_CLEAR_DIALOG_VISIBILITY,
  LEGACY_COMPONENT_USER_DIALOG,
  RESET_SYS_PARAMETERS_STATE,
  HIDE_MC4500_DEPRECATION_ALERT,
  APPTOOLBAR_RESET_MULTIBED_STATE,
  CLEAR_MANIFOLD_MAIN, APPTOOLBAR_SWITCH_CREATE_DIALOG_VISIBILITY, APPTOOLBAR_BASIC_RESET_APP_STATE
} from "../lib/types";
import { generatePipeDesign } from "./pipe-bed-actions";


export const setChamberType = ( chamberType, chamberEndCapType ) => dispatch => {
  // Clean manifolds array first
  dispatch({
    type: CLEAR_MANIFOLD_MAIN
  });

  dispatch({
    type: APPTOOLBAR_SELECT_CHAMBER_TYPE,
    payload: {
      chamberType,
      chamberEndCapType
    }
  });

  // Set constraints from chamber type
  const constraints = chamberType.constraints;
  let defaults = {};
  if (constraints === undefined) {
    return;
  }

  for (let key in constraints) {
    defaults[key] = constraints[key].default;
  }

  dispatch({
    type: APPTOOLBAR_SET_CONSTRAINTS,
    payload: {
      default: defaults
    }
  });
};

export const showSubmitDialog = () => dispatch => {
  dispatch({
    type: SUBMIT_DIALOG_SHOW
  });
};
export const switchClearDialogVisibility = show => dispatch => {
  dispatch({
    type: APPTOOLBAR_SWITCH_CLEAR_DIALOG_VISIBILITY,
    payload: show
  });
};

export const switchCreateDialogVisibility = show => dispatch => {
  dispatch({
    type: APPTOOLBAR_SWITCH_CREATE_DIALOG_VISIBILITY,
    payload: show
  });
};

export const resetAppState = () => ( dispatch, getState ) => {

  dispatch({
    type: APPTOOLBAR_RESET_APP_STATE
  });

  setTimeout(() => {

    dispatch({
      type: RESET_SYS_PARAMETERS_STATE
    });

    generatePipeDesign()(dispatch, getState);
  }, 0);
};
export const resetBasicAppState = () => ( dispatch, getState ) => {

  dispatch({
    type: APPTOOLBAR_BASIC_RESET_APP_STATE
  });

  setTimeout(() => {
    dispatch({
      type: RESET_SYS_PARAMETERS_STATE
    });
    generatePipeDesign()(dispatch, getState);
  }, 0);
};

export const resetAppSettingsState = () => ( dispatch, getState ) => {
  const state = getState();
  const { chamberType } = state.globals;
  dispatch({
    type: APPTOOLBAR_RESET_MULTIBED_STATE,
    payload: {
      chamberType: chamberType
    }
  });
  setTimeout(() => {
    dispatch({
      type: RESET_SYS_PARAMETERS_STATE
    });
  }, 0);
};

export const toggleLegacyComponentDialog = showDialog => dispatch => {
  dispatch({
    type: LEGACY_COMPONENT_USER_DIALOG,
    payload: {
      showDialog: showDialog
    }
  });
};

export const hideMc4500DeprecationAlert = () => dispatch => {
  dispatch({
    type: HIDE_MC4500_DEPRECATION_ALERT
  });
};



// WEBPACK FOOTER //
// ./src/actions/apptoolbar-actions.js